import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';

import { useGetCustomerOrganisations } from 'api';
import { API_URL } from 'constants/environment';

import { setOrganisationId, setRole } from 'reduxLocal/slices/authSlice';

import { AXIOS_INSTANCE } from 'api/mutator/customAxiosInstance';

import { Loading } from 'components/pages/Loading';
import { LoggingIn } from 'components/ui/organisms/LoggingIn';

export const RequireOrganisation = () => {
  const location: { state: any } = useLocation();
  const { organisationId } = useParams();
  const [isUnauthorized, setIsUnauthorized] = useState(false);

  const {
    data: organisationsData,
    isSuccess: organisationsSuccess,
    isLoading: organisationsLoading,
    isError: organisationsError
  } = useGetCustomerOrganisations();

  const {
    mutate: setCurrentOrganisation,
    isPending: currentOrganisationLoading,
    isSuccess: currentOrganisationSuccess,
    isError: currentOrganisationError
  } = useMutation({
    mutationFn: (orgId: string) =>
      AXIOS_INSTANCE({
        url: `${API_URL}/api/v1/customer/organisations/${orgId}/set_current`,
        method: 'POST',
        headers: { 'X-Organisation-ID': orgId }
      })
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (organisationsSuccess && !currentOrganisationLoading) {
      const currentOrganisation = organisationsData.organisations.find(
        (o) => o.id.toString() == organisationId
      );
      if (organisationId && currentOrganisation) {
        setCurrentOrganisation(organisationId);
        dispatch(setOrganisationId(organisationId as unknown as number));
        dispatch(setRole(currentOrganisation.role as unknown as string));
      } else {
        setIsUnauthorized(true);
      }
    }
  }, [organisationsSuccess, organisationId]);

  const isLoading = currentOrganisationLoading || organisationsLoading;
  const isSuccess = currentOrganisationSuccess && organisationsSuccess;

  const noOrganisation =
    currentOrganisationError ||
    organisationsError ||
    organisationsData?.organisations.length == 0 ||
    isUnauthorized;

  return (
    <>
      {isLoading &&
        (location.state?.loggingIn ? (
          <LoggingIn />
        ) : (
          <Loading text="Loading Organisation..." />
        ))}
      {noOrganisation && <Navigate to="/no-organisation" replace />}
      {isSuccess && <Outlet />}
    </>
  );
};
